import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnFilterPipe } from './column-filter.pipe';



@NgModule({
  declarations: [ColumnFilterPipe],
  exports: [
    ColumnFilterPipe
  ],
  imports: [
    CommonModule
  ]
})
export class ColumnFilterModule { }
